import i18next from 'i18next';

// eslint-disable-next-line import/prefer-default-export
export const changeLanguage = (languageKey) => {
  if (!languageKey) {
    return;
  }
  i18next.changeLanguage(languageKey);
};
